// https://www.w3.org/TR/uievents-code/#writing-system-keys
const writingSystemCodes = [
  "Backquote",
  "Backslash",
  "Backspace",
  "BracketLeft",
  "BracketRight",
  "Comma",
  "Digit0",
  "Digit1",
  "Digit2",
  "Digit3",
  "Digit4",
  "Digit5",
  "Digit6",
  "Digit7",
  "Digit8",
  "Digit9",
  "Equal",
  "IntlBackslash",
  "IntlRo",
  "IntlYen",
  "KeyA",
  "KeyB",
  "KeyC",
  "KeyD",
  "KeyE",
  "KeyF",
  "KeyG",
  "KeyH",
  "KeyI",
  "KeyJ",
  "KeyK",
  "KeyL",
  "KeyM",
  "KeyN",
  "KeyO",
  "KeyP",
  "KeyQ",
  "KeyR",
  "KeyS",
  "KeyT",
  "KeyU",
  "KeyV",
  "KeyW",
  "KeyX",
  "KeyY",
  "KeyZ",
  "Minus",
  "Period",
  "Quote",
  "Semicolon",
  "Slash",
];

export const isWritingSystemKeyEvent = (event: React.KeyboardEvent) =>
  writingSystemCodes.includes(event.code) &&
  !event.getModifierState("Control") &&
  !event.getModifierState("Alt") &&
  !event.getModifierState("Meta");

export const isPrintableKeyEvent = (event: React.KeyboardEvent) =>
  event.key.length === 1 &&
  event.key.charCodeAt(0) >= 32 &&
  event.key.charCodeAt(0) <= 126;

export const isAlphanumericKeyEvent = (event: React.KeyboardEvent) =>
  Boolean(event.key.length === 1 && event.key.match(/[a-zA-Z0-9]/));

export const isModifierKeyEvent = (event: React.KeyboardEvent) =>
  event.key === "Shift" ||
  event.key === "Control" ||
  event.key === "Alt" ||
  event.key === "Meta";

export const stopPropagationIfActivationKey = (event: React.KeyboardEvent) => {
  if (event.key === "Enter" || event.key === " ") {
    event.stopPropagation();
  }
};
